import React, { useEffect } from "react";
import TopupRequestForm from "./TopupRequestForm";
import { useAppDispatch } from "../../app/hooks";
import { useLocation, useNavigate } from "react-router";
import { getTopupRequestByID } from "./services/topup.services";
import { IoMdArrowBack } from "react-icons/io";
import { clearTopupRequestDetails } from "./topupSlice";

const TopupRequestFormPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const TopupID = (location as any)?.state?.ID || null;

  useEffect(() => {
    if (TopupID) dispatch(getTopupRequestByID(TopupID));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [TopupID]);

  return (
    <div className="container py-4">
      <div className="d-flex align-items-center mb-3">
        <button
          onClick={() => {
            navigate(-1);
            dispatch(clearTopupRequestDetails());
          }}
          className="btn btn-link me-3"
          style={{
            color: "#00a34d",
            background: "white",
            padding: "8px",
            borderRadius: 6,
            border: "1px solid #e6f4ea",
          }}
        >
          <IoMdArrowBack size={20} />
        </button>
        <h2 className="mb-0">
          {TopupID ? "Edit Top-Up Request" : "Add New Top-Up Request"}
        </h2>
      </div>

      <div className="card border-0 shadow-sm p-4">
        <TopupRequestForm />
      </div>
    </div>
  );
};

export default TopupRequestFormPage;
